// src/hooks/useDomain.ts
import { useEffect, useState } from "react";

const normalizeHost = (host: string) => host.replace(/\/$/, "").toLowerCase();

export default function useDomain() {
  const [host, setHost] = useState<string>(() => {
    // Initialize with the actual host value instead of empty string
    if (typeof window !== "undefined") {
      return normalizeHost(window.location.host);
    }
    return "";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      setHost(normalizeHost(window.location.host));
    }
  }, []);

  const isPrimary = host === "opto.computerized.ai";
  const isDev = host === "dev.optopro.co.uk";

  return { host, isPrimary, isDev };
}
